export const CATEGORY_ALL = {
    name: '전체'
};

export const DISCOVER_TAB = {
    PRODUCT: Symbol('PRODUCT'),
    SHOP: Symbol('SHOP')
};
